import _ from 'lodash'

export default class VectorClick {
  constructor ({
    map
  } = {}) {
    this.map = map
    this.isEnable = true

    this.selectEvents = []

    // Changement du style du curseur lors du survol d'une feature
    this.map.on('pointermove', this._onPointerMove.bind(this))
  }

  enable () {
    this.isEnable = true
  }

  disable () {
    this.isEnable = false
  }

  release () {
    this.selectEvents.forEach((e) => this.map.un('singleclick', e))
    this.map.un('pointermove', this._onPointerMove)
  }

  onSelect (callback) {
    const fct = this._onSelect.bind(this, callback)
    this.selectEvents.push(fct)
    return this.map.on('singleclick', fct)
  }

  _onPointerMove (e) {
    if (!this.isEnable) return

    const pixel = this.map.getEventPixel(e.originalEvent)
    const hit = this.map.hasFeatureAtPixel(pixel)
    this.map.getViewport().style.cursor = hit ? 'pointer' : ''
  }

  _onSelect (callback, e) {
    if (!this.isEnable) return

    const selectedFeature = _.head(this.map.getFeaturesAtPixel(e.pixel))

    if (typeof selectedFeature === 'undefined') return callback({
      coordinate: this.map.getCoordinateFromPixel(e.pixel)
    }, this)

    e.selectedFeature = selectedFeature
    e.coordinate = selectedFeature.getGeometry().getCoordinates()
    callback(e, this)
  }
}
